import styled from 'styled-components'

import Sizes from 'builder/styles/sizes'
import Colors from 'builder/styles/colors'
import { Media } from 'builder/styles/media'

import { Icon20 } from 'builder/components/Icon'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  gap: ${Sizes.S};
  justify-content: center;

  padding: ${Sizes.S} ${Sizes.XS};
  border-radius: ${Sizes['2XS']};
  background-color: ${Colors.Green10};

  ${Media.Phone`
    width: 100%;
    padding: ${Sizes.XS} ${Sizes.S};
  `}
`

export const Item = styled.div`
  display: flex;
  gap: ${Sizes['4XS']};
`

export const Title = styled.p`
  ${Typography.Caption};
  ${FontWeights.Regular};

  color: ${Colors.Green70};

  strong {
    ${FontWeights.DemiBold};
  }
`

export const IconContainer = styled.div``

export const Icon = styled(Icon20.Check)`
  color: ${Colors.Green50};
`

export const SwiperContainer = styled.div`
  width: 100%;
  overflow: hidden;

  & .swiper-container {
    width: 100% !important;
    overflow: hidden;
  }

  & .swiper-wrapper {
    display: flex;
    transition-property: transform;
  }

  & .swiper-slide {
    width: 90% !important;
    flex-shrink: 0;
  }
`
